import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface ProductSearchProps {
  value: string;
  onChange: (value: string) => void;
}

const ProductSearch = ({ value, onChange }: ProductSearchProps) => {
  return (
    <div className="relative max-w-md mx-auto mb-8">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
      <Input
        type="text"
        placeholder="Buscar productos, marcas..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-10 h-12 rounded-full border-2 border-border focus:border-primary transition-colors"
      />
    </div>
  );
};

export default ProductSearch;
